export default "__VITE_ASSET__206db37b__"